module.exports = __webpack_public_path__ + "cement/img/图像 295@2x.5ee8519b.png";